import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Axios from "axios";
import { Row, Col } from "react-bootstrap";

//COMPONENTS
import PrintProgressItem from "./printingProgressItem";

//STYLES
import * as OrderDetailsStyles from "../../styles/order/orderDetails";

function PrintingProgress() {
    const params = useParams();
    const [items, setItems] = useState([]);
    const [orderCompleted, setOrderCompleted] = useState(false);
    const [orderStatus, setOrderStatus] = useState("");

    useEffect(() => {
        loadOrderItems();
    }, []);

    function loadOrderItems() {
        const data = { orderID: params.id, fetchType: "hvs" };
        Axios.post("/pods/3dPrintingShop/orders/getOrderPrintingProgress", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    for (const item of data.items) {
                        const precentage = Math.floor((100 / parseInt(item.mainItem.totalModels)) * parseInt(item.mainItem.totalBuilt));
                        item.mainItem.progress = precentage;

                        if (item.mainItem.quantity > 1) {
                            for (const eItem of item.extraItems) {
                                const precentage = Math.floor((100 / parseInt(eItem.totalModels)) * parseInt(eItem.totalBuilt));
                                eItem.progress = precentage;
                            }
                        }
                    }

                    setItems(data.items);
                    setOrderCompleted(data.orderCompleted);
                    setOrderStatus(data.orderStatus);
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div>
            <div style={OrderDetailsStyles.printingProcess_title}>Order Printing Process</div> <br />
            {
                orderCompleted && (
                    <div>
                        {orderStatus == "Dispatched" ? (
                            <div>
                                <Row>
                                    <Col style={OrderDetailsStyles.printingProcess_dispatch}>Dispatched</Col>
                                </Row>
                            </div>
                        ) : (
                            <div>
                                {" "}
                                <Row>
                                    <Col style={OrderDetailsStyles.printingProcess_dispatch}>Awaiting to be Dispatched</Col>
                                </Row>
                            </div>
                        )}
                    </div>
                )
                // <div style={OrderDetailsStyles.printingProcess_dispatch}>Awaiting to be Dispatched</div>
            }
            <br />
            <Row>
                <Col sm={8}>
                    {items.map((item, index) => {
                        return <PrintProgressItem key={index} mainItem={item.mainItem} extraItems={item.extraItems} reload={loadOrderItems} />;
                    })}
                </Col>
                <Col sm={4}></Col>
            </Row>
        </div>
    );
}

export default PrintingProgress;
